import { WizardService } from "../../../services/wizard/wizard.service";
import { TripSemantics } from "../../create-rule/define-duty/define-duty.component";
import { ValidatedElement } from "../validated-element";
import { getValidatedElementsCommon } from "./define-duty-common.validator";

export function getValidatedElements(wizardService: WizardService): ValidatedElement[] {
	return getValidatedElementsCommon(wizardService, TripSemantics.tripStart);
}
